import { defineSlotRecipe } from "@pandacss/dev";

export const aromaRadio = defineSlotRecipe({
  slots: [
    "groupContainer",
    "itemContainer",
    "control",
    "label",
    "description",
    "errorContainer",
    "errorText",
    "indicator",
    "icon",
    "title",
    "subtitle",
  ],
  className: "aroma-radio",
  jsx: ["Radio", "AromaRadio", "AromaRadioItem", "AromaRadioGroup"],
  base: {
    subtitle: {
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.subtle",
    },
    groupContainer: {
      margin: "padding.3",
      display: "flex",
      flexDirection: "column",
      gap: "gap.0,5",
      maxWidth: "max-content",
    },
    itemContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "gap.2",
      maxWidth: "max-content",
      cursor: "pointer",
      _disabled: {
        cursor: "default",
      },
    },
    icon: {
      alignSelf: "center",
      fontSize: "{sizes.xs}",
    },
    control: {
      width: "xs",
      height: "xs",
      minWidth: "xs",
      borderRadius: "pill",
      border: "{borderWidths.m} solid",
      borderColor: "border.neutral.bold",
      backgroundColor: "background.neutral.base.subtlest",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      _hover: {
        backgroundColor: "background.neutral.base.subtlest-hover",
        borderColor: "border.neutral.bold-hover",
        "& .aroma-radio__indicator": {
          backgroundColor: "background.neutral.base.subtlest-hover",
          borderColor: "border.neutral.bold-hover",
        },
      },
      _focusVisible: {
        borderColor: "border.brand-bold",
        shadow: "effect.focus-ring.brand",
        backgroundColor: "background.neutral.base.subtlest",
        "& .aroma-radio__indicator": {
          backgroundColor: "background.neutral.base.subtlest",
        },
      },
      _invalid: {
        backgroundColor: "background.functional.error.subtle",
        borderColor: "content.functional.error",
        "& .aroma-radio__indicator": {
          backgroundColor: "background.functional.error.subtle",
        },
        _hover: {
          backgroundColor: "background.functional.error.subtle-hover",
          borderColor: "content.functional.error",
          "& .aroma-radio__indicator": {
            backgroundColor: "background.functional.error.subtle-hover",
          },
        },
        _focusVisible: {
          borderColor: "content.functional.error",
          shadow: "effect.focus-ring.error",
        },
      },
      _disabled: {
        backgroundColor: "background.neutral.disable.bold",
        borderColor: "background.neutral.disable.bold",
        "& .aroma-radio__indicator": {
          backgroundColor: "background.neutral.disable.bold",
        },
        _hover: {
          backgroundColor: "background.neutral.disable.bold",
          borderColor: "background.neutral.disable.bold",
          "& .aroma-radio__indicator": {
            backgroundColor: "background.neutral.disable.bold",
          },
        },
      },
      _checked: {
        backgroundColor: "background.brand.bold",
        borderColor: "background.brand.bold",
        _hover: {
          backgroundColor: "background.brand.bold-hover",
          borderColor: "background.brand.bold-hover",
        },
        _focusVisible: {
          backgroundColor: "background.brand.bold",
          borderColor: "border.brand-bold",
          shadow: "effect.focus-ring.brand",
        },
        _invalid: {
          backgroundColor: "content.functional.error",
          borderColor: "content.functional.error",
          "& .aroma-radio__indicator": {
            backgroundColor: "content.neutral.reverse.bold",
          },
          _hover: {
            backgroundColor: "background.functional.error.bold-hover",
          },
          _focusVisible: {
            borderColor: "content.functional.error",
            shadow: "effect.focus-ring.error",
          },
        },
        _disabled: {
          backgroundColor: "background.brand.subtle",
          borderColor: "background.brand.subtle",
          "& .aroma-radio__indicator": {
            backgroundColor: "content.brand.subtlest",
          },
        },
      },
    },
    indicator: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      top: "auto!",
      backgroundColor: "content.neutral.reverse.bold",
    },
    label: {
      textStyle: "title.s",
      color: "content.neutral.base",
    },
    description: {
      textStyle: "paragraph.m.regular",
    },
    errorContainer: {
      display: "flex",
      alignItems: "center",
      gap: "gap.1",
      color: "content.functional.error",
    },
    errorText: {
      textStyle: "title.2xs",
    },
  },
  variants: {
    hierarchy: {
      bold: {
        label: {
          fontWeight: "bold",
        },
        title: {
          textStyle: "title.s",
        },
      },
      subtle: {
        label: {
          textStyle: "paragraph.m.regular",
        },
        title: {
          textStyle: "paragraph.m.regular",
        },
        subtitle: {
          display: "none",
        },
        description: {
          display: "none",
        },
        errorContainer: {
          display: "none",
        },
      },
    },
  },
  defaultVariants: {
    hierarchy: "bold",
  },
});
